import { PRUAGENCY_ENUM } from "./index";

export const getPruAgencyStatus = value => {
  const groupA = { 3: "GHS", 4: "GMM", 5: "GADD" };
  const groupB = { 0: "VTLB", 1: "VCCA", 2: "VECI" };

  return {
    isPruAgencyEnrolment: value in groupB,
    isPruAgencyMed: value in groupA,
    GHS: value === 3,
    GMM: value === 4,
    GADD: value === 5,
    VTLB: value === 0,
    VCCA: value === 1,
    VECI: value === 2
  };
};

export const myDepSelectMapVollife = myDependentSelectMap => {
  const vollifeMap = new Map();
  myDependentSelectMap.forEach((value, key) => {
    if (Array.isArray(value)) {
      const filteredValues = value.filter(
        dep => dep.planDep.pruscheme === "vollife"
      );
      if (filteredValues.length > 0) {
        vollifeMap.set(key, filteredValues);
      }
    }
  });
  return vollifeMap;
};

export const myDepSelectMapPrumed = myDependentSelectMap => {
  const prumedMap = new Map();
  myDependentSelectMap.forEach((value, key) => {
    if (Array.isArray(value)) {
      const filteredValues = value.filter(
        dep => dep.planDep.pruscheme === "prumed"
      );
      if (filteredValues.length > 0) {
        prumedMap.set(key, filteredValues);
      }
    }
  });

  return prumedMap;
};

export const filterRateMatrics = (rateMatrics, schemeType) => {
  return rateMatrics
    .map(rateMatric => ({
      details: rateMatric.details.filter(
        detail => detail.pruscheme === schemeType
      )
    }))
    .filter(rateMatric => rateMatric.details.length > 0);
};

export function segregatePlan(planSelected) {
  let planSelectedVollife = new Map();
  let planSelectedPrumed = new Map();

  planSelected.forEach((value, key) => {
    if (value && value.pruscheme) {
      if (value.pruscheme === PRUAGENCY_ENUM.CLIENT_NAME.VOL_LIFE) {
        planSelectedVollife.set(key, value);
      } else if (value.pruscheme === PRUAGENCY_ENUM.CLIENT_NAME.PRU_MED) {
        planSelectedPrumed.set(key, value);
      }
    }
  });

  return { planSelectedVollife, planSelectedPrumed };
}
export const handleNextOnPruScheme = (showDependentBadge, user, state) => {
  const allBadgesValid = Array.from(showDependentBadge.values()).every(
    value => value
  );
  const isExistInsured =
    user.add_scheme_existing_member || user.existing_insured;
  const isAllBadgesValidAndComplete =
    allBadgesValid && showDependentBadge.size === 6;

  if (isAllBadgesValidAndComplete) {
    return true;
  }
  return false;
};

export const validateNextForNewMember = state => {
  const planSelectedArray = Array.from(state.planSelected.entries());
  let planSelectedTabVollife = new Map();
  let planSelectedTabMed = new Map();

  const pruAgencyPlanTypes = [
    PRUAGENCY_ENUM.VOLLIFE_PLAN.VTLB,
    PRUAGENCY_ENUM.VOLLIFE_PLAN.VCCA,
    PRUAGENCY_ENUM.VOLLIFE_PLAN.VECI
  ];
  const prumedPlanTypes = [
    PRUAGENCY_ENUM.PRUMED_PLAN.GHS,
    PRUAGENCY_ENUM.PRUMED_PLAN.GMM,
    PRUAGENCY_ENUM.PRUMED_PLAN.GADD
  ];

  planSelectedArray.forEach(([key, value]) => {
    if (pruAgencyPlanTypes.includes(key)) {
      planSelectedTabVollife.set(key, value);
    } else if (prumedPlanTypes.includes(key)) {
      planSelectedTabMed.set(key, value);
    }
  });

  // Convert maps to arrays of [key, value] pairs
  const vollife = Array.from(planSelectedTabVollife.entries());
  const prumed = Array.from(planSelectedTabMed.entries());

  // Check that every entry in the vollife array does not have "Opt Out" as its value
  const isVollifePass = vollife.every(
    ([key, value]) => value !== PRUAGENCY_ENUM.OPTION_OUT.OUT
  );

  // Check that every entry in the prumed array does not have "Opt Out" as its value
  const isPrumedPass = prumed.every(
    ([key, value]) => value !== PRUAGENCY_ENUM.OPTION_OUT.OUT
  );
  return isVollifePass || isPrumedPass;
};
